// @flow
import React, { Component } from 'react';
import { I18n } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import { CardNumberElement } from 'react-stripe-elements';

import { MQ } from '@rover/react-lib/styles';
import CreditCardIcon from '@rover/react-lib/components/typography/CreditCardIcon';
import { CARD_TYPES } from '@rover/react-lib/constants/creditCard.constants';

import type { CreditCardType } from '../../../types/CreditCard';
import type { StripeChangeEvent } from './StripeCreditCardForm';
import StripeFormGroup, { createStyledStripeElement } from './StripeFormGroup';

const StyledStripeFormGroup: StyledComponent<
  React$ElementConfig<typeof StripeFormGroup>,
  {},
  any
> = styled(StripeFormGroup)`
  flex: 1;
  flex-basis: 100%;

  ${MQ.NOT_XS} {
    flex-basis: 200px;
  }
`;

const InnerWrapper: StyledComponent<{}> = styled.div`
  position: relative;
`;

export const StyledCardNumberElement = createStyledStripeElement(CardNumberElement);

type StyledCreditCardIconProps = React$ElementConfig<typeof CreditCardIcon>;

export const StyledCreditCardIcon: StyledComponent<StyledCreditCardIconProps> = styled(
  CreditCardIcon
)`
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -11px;
`;

export type Props = {
  onChange: StripeChangeEvent => void,
};

type State = {
  cardType: ?CreditCardType,
};

export default class StripeCreditCardNumberField extends Component<Props, State> {
  state = {
    cardType: null,
  };

  handleChange = (e: StripeChangeEvent) => {
    if (e.brand) {
      const cardType = CARD_TYPES[e.brand] ? CARD_TYPES[e.brand].id : null;
      this.setState(() => ({ cardType }));
    }
    this.props.onChange(e);
  };

  render() {
    const { cardType } = this.state;
    return (
      <I18n>
        {({ i18n }) => (
          <StyledStripeFormGroup {...this.props} label={i18n._('Card Number')}>
            {formGroupProps => (
              <InnerWrapper>
                <StyledCardNumberElement {...formGroupProps} onChange={this.handleChange} />
                <StyledCreditCardIcon type={cardType} />
              </InnerWrapper>
            )}
          </StyledStripeFormGroup>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardNumberField.jsx